import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import resultDeclarationapi from '../api/resultDeclaration';
import loginapi from '../api/login';
import { AiOutlineDownload } from "react-icons/ai";


import { APISERVERURL } from '../APIServerURL';


const StudentResult = ({ result,slno}) => {
  return (
    <div id="containerdiv" className="w-full p-1     mb-2 ">   

        <div
          id="coursesdiv"
          className="text-center w-full max-w-full  grid grid-cols-[.5fr_1.5fr_2fr_4fr_1fr_2fr_2fr_2fr] lg:gap-1 md:p-1 text-sm"
        >
                              
                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">SlNo</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {slno}
                       </p>
                  </div>
                </div>

               
                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">RollNO</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.rollno}
                       </p>
                  </div>
                </div> 


                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Name</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.name}
                       </p>
                  </div>
                </div> 

                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Sem</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.semester}
                       </p>
                  </div>
                </div> 


                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">SGPA</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.sgpaall}
                       </p>
                  </div>
                </div> 


                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">CrdtErned</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.credit_earned}
                       </p>
                  </div>
                </div> 

                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Result</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.result}
                       </p>
                  </div>
                </div> 

                <div className="w-full flex px-2">
                  <div className="w-full flex flex-col">      
                    <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">GrdCrdNo</label>
                       <p                        
                        className="w-full border rounded p-2 mt-1"
                       >
                        {result.gradecard_slno}
                       </p>
                  </div>
                </div> 


        </div>
  </div>
  );
};




const ResultDeclarationForm = ({accessToken,setAccessToken,setRefreshFailed}) => {
  const [status, setStatus] = useState('pending');
  const [date, setDate] = useState(""); // State for storing date
  const [issueDate, setIssueDate] = useState(""); // State for storing date
  const [resultDataLoaded,setResultDataLoaded]=useState(false);
  const [studentList,setStudentList]=useState([]);
  const [studentListLoaded,setStudentListLoaded]=useState(false);
  const [examMonth,setExamMonth]=useState('');
  const [examYear,setExamYear]=useState('');
  const [examType,setExamType]=useState('');

  const navigate = useNavigate();
  const { batch, session, semester } = useParams();

  const handleGoBack = () => {
    navigate('/resultdeclarationbatches');      
  };

  const handleStatusChange = async() => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await resultDeclarationapi.post('/upDateResultStateOfABatchSemester',{session,batch,semester,status,date},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setStatus(response.data.status);
      //setDate(response.data.date);

      //setResultDataLoaded(true);
      setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
      //setStatus(response.data.date);
      //alert(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await resultDeclarationapi.post('/upDateResultStateOfABatchSemester',{session,batch,semester,status,date},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  const handleDateChange = async(e) => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await resultDeclarationapi.post('/upDateResultDateOfABatchSemester',{session,batch,semester,date:e.target.value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setStatus(response.data.status);
      //setDate(response.data.date);

      //setResultDataLoaded(true);
      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
      //setStatus(response.data.date);
      //alert(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await resultDeclarationapi.post('/upDateResultDateOfABatchSemester',{session,batch,semester,date:e.target.value},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  const handleIssueDateChange = async(e) => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await resultDeclarationapi.post('/upDateIssueDateOfABatchSemester',{session,batch,semester,date:e.target.value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setStatus(response.data.status);
      //setDate(response.data.date);

      //setResultDataLoaded(true);
      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
      //setStatus(response.data.date);
      //alert(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await resultDeclarationapi.post('/upDateIssueDateOfABatchSemester',{session,batch,semester,date:e.target.value},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };

  const handleExamMonthChange = async(e) => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await resultDeclarationapi.post('/upDateExamMonth',{session,batch,semester,examMonth:e.target.value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await resultDeclarationapi.post('/upDateExamMonth',{session,batch,semester,examMonth:e.target.value},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  const handleExamTypeChange = async(e) => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await resultDeclarationapi.post('/upDateExamType',{session,batch,semester,examType:e.target.value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await resultDeclarationapi.post('/upDateExamType',{session,batch,semester,examType:e.target.value},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  
  const handleExamYearChange = async(e) => {
   
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await resultDeclarationapi.post('/upDateExamYear',{session,batch,semester,examYear:e.target.value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await resultDeclarationapi.post('/upDateExamYear',{session,batch,semester,examYear:e.target.value},{headers:{'Authorization':`Bearer ${nat}`}});   
                      //setStatus(response.data.status);
                      //setDate(response.data.date);
                      
                      //setResultDataLoaded(true);
                      //setStatus((prevStatus) => (prevStatus === "declared" ? "pending" : "declared"));
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  };
  
  
  const fetchAllFormFillupStudents=async ()=>{
    setResultDataLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await resultDeclarationapi.post('/getResultDeclarationOfABatchSemester',{session,batch,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        //alert(JSON.stringify(response.data));
        setStatus(response.data.status);
        setDate(response.data.date);
        setIssueDate(response.data.issue_date);
        setExamMonth(response.data.examMonth);
        setExamYear(response.data.examYear);
        setExamType(response.data.examType);
        setStudentList(response.data.studentList);
        //alert(JSON.stringify(response.data.studentList));
        setResultDataLoaded(true);
        // alert('ok');
        //alert(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await resultDeclarationapi.post('/getResultDeclarationOfABatchSemester',{session,batch,semester},{headers:{'Authorization':`Bearer ${nat}`}});   
                        setStatus(response.data.status);
                        setDate(response.data.date);
                        setIssueDate(response.data.issue_date);
                        setExamMonth(response.data.examMonth);
                        setExamYear(response.data.examYear);
                        setExamType(response.data.examType);
                        setStudentList(response.data.studentList);
                        setResultDataLoaded(true);
                        //alert('ok');
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
              setResultDataLoaded(true);
            }
    }

  

  useEffect(()=>{
    fetchAllFormFillupStudents();
  },[]);

 

  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }

  async function handleDownloadCSV(e)
    {
      e.preventDefault();
      try{
        await downloadCSV();
        await fetchAllFormFillupStudents();
      }
      catch(err)
      {

      }
    }

  async function downloadCSV()
    {
      
      try{
        const response= await resultDeclarationapi.post('/getResultOfABatchSemesterCSV',{session,batch,semester},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        //alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await resultDeclarationapi.post('/getResultOfABatchSemesterCSV',{session,batch,semester},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
    }

async function downloadAllGradeCards(e,bg)
    {
      
      try{
        const response= await resultDeclarationapi.post('/downloadAllGradeCardsOfASessionSemBatch',{session,batch,semester,bg},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await resultDeclarationapi.post('/downloadAllGradeCardsOfASessionSemBatch',{session,batch,semester,bg},{headers:{'Authorization':`Bearer ${nat}`}});    
            alert(response.data);
            downloadFile(response.data);
           }
           catch(err)
           {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
    }
  return (
    <main className="w-full">
    <div className="flex flex-col items-center w-full">


    <div className="w-full bg-red-100 relative py-1 flex flex-col justify-center">
       {/* Absolute Positioned Button */}
       <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
         BACK
       </button>

       {/* Heading */}
       <div className="w-full flex justify-center">
        <h1 className="text-2xl  text-gray-400 text-center">RESULT DECLARATION FORM</h1>
       </div>
       <p className="w-full text-center font-semibold text-xs">({batch},{session})</p>    
     </div>

    
    {resultDataLoaded && <div className="w-[98%] max-w-[1200px] flex flex-col items-center justify-center">
      
      <div className="flex items-center justify-start space-x-2 p-1 rounded-md w-[98%] max-w-[400px] mt-6">
        <input
          type="checkbox"
          id="declaredCheckbox"
          checked={status==='declared'}
          onChange={handleStatusChange}
          className="w-5 h-5 accent-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-offset-2 cursor-pointer"
        />
        <label
          htmlFor="declaredCheckbox"
          className="text-lg text-gray-700 cursor-pointer transition-colors duration-200 hover:text-blue-600"
        >
          Mark as declared
        </label>
      </div>

      <div className="flex flex-col space-y-2 w-[98%] max-w-[400px] mt-6">
        <label htmlFor="dateInput" className="text-lg text-gray-500  p-2">
          Result Declaration Date
        </label>
        <input
          type="date"
          id="dateInput"
          value={date}
          onChange={(e) => {
            //const formattedDate = formatDate(e.target.value);
            setDate(e.target.value);
            handleDateChange(e);
          }}
          onBlur={(e) => {
            //alert(date);
          }}
          className="px-2 py-4 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <div className="flex flex-col space-y-2 w-[98%] max-w-[400px] mt-6">
        <label htmlFor="dateInput" className="text-lg text-gray-500  p-2">
          Grade Card Issue Date
        </label>
        <input
          type="date"
          id="issuedateInput"
          value={issueDate}
          onChange={(e) => {
            //const formattedDate = formatDate(e.target.value);
            setIssueDate(e.target.value);
            handleIssueDateChange(e);
          }}
          onBlur={(e) => {
            //alert(date);
          }}
          className="px-2 py-4 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <div className="w-[98%] max-w-[400px] mt-6 flex flex-col">      
                      <label className="text-xs text-gray-500 border-b-[1px] border-gray-600">Exam Mnth,Yr,Type</label>
                         <div className="w-full flex gap-1">
                           <select
                              name="exam_month"
                              value={examMonth}
                              onChange={(e) => {
                                //const formattedDate = formatDate(e.target.value);
                                setExamMonth(e.target.value);
                                handleExamMonthChange(e);
                              }}
                              className="w-full border-b-2 border-blue-500 p-2 text-sm mt-1"
                            >
                              <option value="">SELECT</option>
                              <option value="JANUARY">JANUARY</option>
                              <option value="FEBRUARY">FEBRUARY</option>
                              <option value="MARCH">MARCH</option>
                              <option value="APRIL">APRIL</option>
                              <option value="MAY">MAY</option>
                              <option value="JUNE">JUNE</option>
                              <option value="JULY">JULY</option>
                              <option value="AUGUST">AUGUST</option>
                              <option value="SEPTEMBER">SEPTEMBER</option>
                              <option value="OCTOBER">OCTOBER</option>
                              <option value="NOVEMBER">NOVEMBER</option>
                              <option value="DECEMBER">DECEMBER</option>
                            </select>

                            <select
                                name="exam_year"
                                value={examYear}
                                onChange={(e) => {
                                //const formattedDate = formatDate(e.target.value);
                                setExamYear(e.target.value);
                                handleExamYearChange(e);
                              }}
                                className="w-full border-b-2 border-blue-500 p-2 text-sm mt-1"
                              >
                                <option value="">SELECT</option>
                                {[...Array(2032 - 2019 + 1)].map((_, index) => {
                                  const year = 2019 + index;
                                  return (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  );
                                })}
                              </select>

                              <select
                              name="exam_type"
                              value={examType}
                              onChange={(e) => {
                                //const formattedDate = formatDate(e.target.value);
                                setExamType(e.target.value);
                                handleExamTypeChange(e);
                              }}
                              className="w-full border-b-2 border-blue-500 p-2 text-sm mt-1"
                            >
                              <option value="">SELECT</option>
                              <option value="REGULAR">REGULAR</option>
                              <option value="ARREAR">ARREAR</option>
                              <option value="BETTERMENT">BETTERMENT</option>
                            </select>
                         </div>

                         
                    </div>


      
        <div className="w-full text-xs bg-gray-200 border-b text-center mt-6  flex justify-between p-2 mb-1">
            <button 
              onClick={(e) => downloadAllGradeCards(e,'yes')} 
              className="flex items-center gap-2 bg-orange-600 text-white px-4 py-2 rounded-lg hover:bg-orange-700 transition duration-200"
            >
              <AiOutlineDownload size={20} />
              Bg GradeCards
            </button>

            <button 
              onClick={(e) => downloadAllGradeCards(e,'no')} 
              className="flex items-center gap-2 bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition duration-200"
            >
              <AiOutlineDownload size={20} />
              Bare GradeCards
            </button>

            <button 
              onClick={handleDownloadCSV} 
              className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition duration-200"
            >
              <AiOutlineDownload size={20} />
              DETAILED RESULT
            </button>
        </div>
       
    <div className="w-full bg-gray-200">
    {studentList.map((course, index) => (
            <StudentResult
              key={index}
              slno={index+1}
              result={course}
            />
          ))}
    </div>

    </div>
   }
   {
   !resultDataLoaded && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </div>
    </main>
  );
};

export default ResultDeclarationForm;
